module.exports = __webpack_public_path__ + "static/media/vLogo.17c6ae85.png";